import { getFlowSteps } from '../flow-initial/getFlowConfig';
import { FlowManager } from '../flow-management/FlowManager';
import { setFlow } from '../store/flow/action-creators';
import { Step } from '../views/Step';
export const setFlowAfterGoogleCredentialAuthentication = response => dispatch => {
  const stepsToRemove = [...(response.email ? [Step.LandingPage] : []), Step.Verification, Step.CodeVerification];
  const preVerificationSteps = FlowManager.removeSteps(...stepsToRemove)(getFlowSteps().preVerification);
  const postVerificationSteps = FlowManager.removeSteps(...[Step.Password, ...(response.firstName && response.lastName ? [Step.Name] : [])])(getFlowSteps().postVerification);
  const postAccountCreationSteps = getFlowSteps().postAccountCreation;
  const postExistingAccountSelectionSteps = getFlowSteps().postExistingAccountSelection;
  const nextSteps = [...preVerificationSteps, ...postVerificationSteps, ...postAccountCreationSteps];
  dispatch(setFlow(nextSteps, preVerificationSteps, postVerificationSteps, postAccountCreationSteps, postExistingAccountSelectionSteps));
};